import { render, staticRenderFns } from "./CampaignCrypto.vue?vue&type=template&id=3439dbf2&scoped=true"
import script from "./CampaignCrypto.vue?vue&type=script&lang=js"
export * from "./CampaignCrypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439dbf2",
  null
  
)

export default component.exports